import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Get root element and ensure it exists
const rootElement = document.getElementById("root");

// Create root and render app with strict mode disabled to avoid double renders in development
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(<App />);
} else {
  console.error("Root element not found. Check your HTML structure.");
}
